import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1l": "#E4B670",
    "col1n": "#D19532",
    "col2n": "#FFFFFF"
}
function SkiWou018({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M44.8 32.5q1.2-2.7.65-4.25L24 6.8v-.05L17.45.2h-.05q-1.6-.55-4.25.6Q9.65 2.35 6 5.85L5.85 6l-.3.3Q2.3 9.75.85 13.1-.4 15.85.2 17.45l6.25 6.25H6.4l21.8 21.8q1.6.5 4.3-.7 3.5-1.5 7.1-5l.15-.15.35-.35q3.3-3.4 4.7-6.8z"
                    id="SkiWou018__Symbol_40_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M5.55 6.3Q2.3 9.75.85 13.1-.4 15.85.2 17.45L6.75 24 24 6.75 17.45.2q-1.6-.6-4.3.6Q9.65 2.35 6 5.85L5.85 6l-.3.3M40.8 39.95q3.3-3.4 4.7-6.8 1.2-2.7.65-4.25l-6.6-6.6L22.3 39.55l6.6 6.6q1.6.5 4.3-.7 3.5-1.5 7.1-5l.15-.15.35-.35z"
                    id="SkiWou018__Symbol_36_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M16.75 14.4q-.65-.35-1.35-.05-.65.3-1.05.9-.3.65-.05 1.4.2.6.85.95.7.3 1.35.05.75-.25 1.1-.9.15-.3.15-.65 0-.4-.1-.7-.25-.65-.9-1m-7.5 7.3q.15.65.8 1 .7.3 1.4 0 .65-.25 1.05-.85.1-.35.15-.65 0-.4-.1-.7-.25-.65-.9-1t-1.3-.05q-.75.2-1.1.85-.3.7 0 1.4m-2-6.7q-.7-.3-1.35-.05-.75.25-1.1.9-.3.7 0 1.4.2.6.85 1 .65.3 1.35 0 .65-.25 1.05-.85.1-.35.2-.65-.05-.4-.15-.7-.25-.65-.85-1.05M2.6 10.35q-.7-.3-1.35-.05-.75.25-1.1.9-.3.7 0 1.4.2.6.85 1 .65.3 1.35 0 .65-.25 1.05-.85.1-.35.2-.65-.05-.4-.15-.7-.25-.65-.85-1.05M7.65 5.3q-.65-.35-1.3-.1-.75.25-1.1.9-.3.7 0 1.4.2.65.8 1 .7.3 1.4 0 .65-.25 1.05-.85.1-.35.15-.65 0-.4-.1-.7-.25-.65-.9-1m4.65 4.65q-.65-.35-1.3-.1-.75.25-1.1.9-.3.7 0 1.4.2.65.8 1 .7.3 1.4 0 .65-.25 1.05-.85.1-.35.15-.65 0-.4-.1-.7-.25-.65-.9-1m1.35-8.75q-.25-.65-.9-1t-1.3-.05q-.75.2-1.1.85-.3.7 0 1.4.15.65.8 1 .7.3 1.4 0 .65-.25 1.05-.85.1-.35.15-.65 0-.4-.1-.7m3.75 3.65q-.65-.35-1.3-.05-.75.2-1.1.85-.3.7 0 1.4.15.65.8 1 .7.3 1.4 0 .65-.25 1.05-.85.1-.35.15-.65 0-.4-.1-.7-.25-.65-.9-1m4.45 4.45q-.7-.3-1.35-.05-.7.3-1.1.9-.25.7 0 1.4.2.6.85.95.65.35 1.35.05.75-.2 1.05-.85.15-.35.2-.7-.05-.35-.1-.65-.25-.7-.9-1.05z"
                    id="SkiWou018__Symbol_37_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiWou018__Symbol_40_0_Layer0_0_FILL"
                transform="translate(234.7 109.95)"
                id="SkiWou018__col1n"
            />
            <use
                xlinkHref="#SkiWou018__Symbol_36_0_Layer0_0_FILL"
                transform="translate(234.35 109.65)"
                id="SkiWou018__col1l"
            />
            <use
                xlinkHref="#SkiWou018__Symbol_37_0_Layer0_0_FILL"
                transform="translate(246.2 121.3)"
                id="SkiWou018__col2n"
            />
        </g></g>
    )
}
export default SkiWou018
